/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_ExportInputs */

const cs_gdpr_export = /** @type {(inputs: Gdpr_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportovat data (JSON)`)
};

const en_gdpr_export = /** @type {(inputs: Gdpr_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export data (JSON)`)
};

/**
* | output |
* | --- |
* | "Export data (JSON)" |
*
* @param {Gdpr_ExportInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_export = /** @type {((inputs?: Gdpr_ExportInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_ExportInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_export(inputs)
	return cs_gdpr_export(inputs)
});